import { render, staticRenderFns } from "./Outstandings.vue?vue&type=template&id=27ff1924&scoped=true&"
import script from "./Outstandings.vue?vue&type=script&lang=js&"
export * from "./Outstandings.vue?vue&type=script&lang=js&"
import style0 from "./Outstandings.vue?vue&type=style&index=0&id=27ff1924&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ff1924",
  null
  
)

export default component.exports